/** @format */

import {SearchWithContext} from '../../components/search/search';
import {AccountBalance} from './account_balance/account_balance';
import {useChargesAndInvoices} from './use_charges_and_invoices';
import {withRouter, If, Loading} from 'frontier-utilities';
import {withSearch} from '../../../components/search';
import {Tabs, Tab} from '@sttark/design-system';
import React, {useEffect, useState} from 'react';
import {Invoices} from './invoice/container';
import {Charges} from './charge/container';
import AllInvoices from './all_invoices';
import {Outlet} from 'react-router-dom';

const TAB_UNPAID = 1;
const TAB_ALL = 2;

// styles
import './invoices_table.scss';
import './container.scss';

export default withRouter(
    withSearchProps(
        withSearch(function InvoicesContainer() {
            const chargesAndInvoices = useChargesAndInvoices();

            const creditUtilization = chargesAndInvoices.dues.invoices;
            const pastDueAmount = chargesAndInvoices.pastDues.invoices;
            const creditLimit = chargesAndInvoices.invoices.limit;
            const isNet30 = chargesAndInvoices.invoices.isNet30;
            const invoices = chargesAndInvoices.invoices.carts;
            const dueAmount = chargesAndInvoices.dues.total;
            const charges = chargesAndInvoices.charges;

            const totalDuesCount = invoices.length + charges.length;

            const [activeTab, setActiveTab] = useState(TAB_ALL);

            useEffect(() => {
                setActiveTab(totalDuesCount ? TAB_UNPAID : TAB_ALL);
            }, [totalDuesCount]);

            const handleTabChange = tab => {
                setActiveTab(tab);
            };

            if (chargesAndInvoices.isLoading) {
                return <Loading message="Loading invoices and charges" color="white" />;
            }

            return (
                <div className="container-invoices-charges-09">
                    <div
                        className={
                            'container-invoices-charges-09__search-toggles d-flex align-items-center justify-content-start gap-4'
                        }>
                        <div className="w-100">
                            <SearchWithContext
                                placeholder="Search by PO #, Order # and Invoice #"
                                filter_option_list={['filter_order_id', 'po_number']}
                            />
                        </div>
                        <If condition={charges?.length > 0}>
                            <button
                                className="btn pay-action-09__pay-btn flex-shrink-0"
                                onClick={() => chargesAndInvoices.handleToggleModal('charges')}>
                                Pay multiple charges
                            </button>
                        </If>
                        <If condition={invoices?.length > 0}>
                            <button
                                className="btn pay-action-09__pay-btn flex-shrink-0"
                                onClick={() => chargesAndInvoices.handleToggleModal('invoices')}>
                                Pay multiple invoices
                            </button>
                        </If>
                    </div>

                    <AccountBalance
                        style={{marginBottom: '16px'}}
                        pastDueAmount={pastDueAmount}
                        current={creditUtilization}
                        maxCredit={creditLimit}
                        dueAmount={dueAmount}
                        isNet30={isNet30}
                    />
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <Tabs
                            onChange={handleTabChange}
                            activeTab={activeTab}
                            className="tabs mb-0">
                            <Tab
                                title={
                                    totalDuesCount > 0
                                        ? `Unpaid Invoices & Charges (${totalDuesCount})`
                                        : ''
                                }
                                name={TAB_UNPAID}
                            />
                            <Tab title={'All Invoices'} name={TAB_ALL} />
                        </Tabs>
                        {totalDuesCount > 0 && activeTab === TAB_UNPAID && (
                            <div className="d-flex gap-2">
                                <a
                                    href="/account/carts/download-unpaid-invoices"
                                    className="btn btn-secondary"
                                    target="_blank"
                                    rel="noopener noreferrer">
                                    <i className="fa fa-file-pdf" style={{marginRight: '5px'}}></i>
                                    Download PDF Report
                                </a>
                                <a
                                    href="/account/carts/download-unpaid-invoices?format=csv"
                                    className="btn btn-secondary"
                                    target="_blank"
                                    rel="noopener noreferrer">
                                    <i className="fa fa-file-csv" style={{marginRight: '5px'}}></i>
                                    Download CSV
                                </a>
                            </div>
                        )}
                    </div>
                    {activeTab === TAB_UNPAID && (
                        <>
                            <Invoices
                                {...chargesAndInvoices}
                                className={'container-invoices-charges-09__invoices'}
                            />
                            <If condition={charges.length > 0}>
                                <h4>Other Outstanding Charges</h4>
                            </If>
                            <Charges {...chargesAndInvoices} />
                        </>
                    )}
                    {activeTab === TAB_ALL && <AllInvoices {...chargesAndInvoices} />}
                    <Outlet />
                </div>
            );
        })
    )
);

function withSearchProps(Component) {
    return props => {
        const searchProps = {
            action: '/account/carts/index',
            searchKey: 'allInvoices'
        };

        return <Component {...props} {...searchProps} />;
    };
}
